import { ThemeConfig, theme } from "antd";
export const PTSTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: "#635DE8",
    wireframe: false,
    colorTextBase: "rgba(18, 13, 21, 1)",
    colorBgBase: "#f8f8fe",
    colorLink: "#635de8",
    fontSize: 14,
    colorBorder: "#E8E8FF",
    borderRadius: 5,
  },
  components: {
    Button: {
      colorPrimary: "#635DE8",
      controlHeight: 40,
      paddingInline: 24,
      paddingBlock: 16,
    },
    Card: {
      colorBgBase: "#f8f8fe",
    },
    Input: {
      colorBgBase: "#f8f8fe",
      // paddingInline: 16,
      // paddingBlock: 12,
    },
    Select: {
      colorBgBase: "#f8f8fe",
      // paddingContentHorizontal: 16,
      // paddingContentVertical: 12,
    },
    Table: {
      colorBgBase: "#f8f8fe",
    },
    Tag: {
      colorBgBase: "rgba(0,0,0,0.88)",
    },
    Tabs: {
      colorBgBase: "#f8f8fe",
    },
    Typography: {
      colorTextBase: "#66697c",
    },
    Modal: {
      colorBgBase: "#f8f8fe",
    },
    Pagination: {
      colorBgBase: "#f8f8fe",
    },
    Popover: {
      colorBgBase: "#f8f8fe",
    },
    Radio: {
      colorBgBase: "#f8f8fe",
    },
    Switch: {
      colorBgBase: "#f8f8fe",
    },
    Tooltip: {
      colorBgSpotlight: "#66697C",
    },
  },
};
